// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__e0DMN","inner":"Form_inner__11_Id","range":"Form_range__2s5uR","name":"Form_name__4j0Vq","actions":"Form_actions__2I-6k"};